import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../BundleResourceConfig";
import { getOneChitAryById } from "../../config/WeChatChitChatConfig";
import { getOneWeChatTriggerTimeLinkById } from "../../config/WeChatTriggerTimeLinkConfig";
import { AccountItem } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import WeChatFrame from "../weChat/WeChatFrame";
import { getBankCooperativeMap } from "./cooperativeConst";
import cooperativeItem from "./cooperativeItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class cooperativeBankPage extends cc.Component {

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"item预制体"})
    itemPrefab:cc.Prefab = null;

    isTrue:boolean = false;

    complete?:(isTrue:boolean)=>void

    bindData(complete?:(isTrue)=>void){
        this.complete = complete;
    }

    onLoad(){
        this.loadPage();
    }

    loadPage(){
        let dataAry = NormalGameManager._instance.getGameData().bankCooperativeData;
        for(let i of dataAry){
            let item:cc.Node = cc.instantiate(this.itemPrefab);
            let is = item.getComponent(cooperativeItem);
            let data = getBankCooperativeMap()[i];
            is.bindData(data,this.selectOne.bind(this));
            item.setParent(this.itemContent);
        }
    }

    selectOne(node:cc.Node){
        let ns = node.getComponent(cooperativeItem);
        let data = ns.data;
        let param = data.param;
        if(data.isOnly && NormalGameManager._instance.getGameData().hasBankCooperativeData.includes(data.id)){
            O1HD.getModules().uiControlModule.showMessageBox("已经办理过该业务");
            return;
        }
        let handleFun = ()=>{
            let pAccountItem = param["accountInfo"];
            if(pAccountItem){
                let accountItem : AccountItem[] = [
                    {
                        uniqueId:`${NormalGameManager._instance.getGameData().userAccountInfo.length+1}`,
                        title : pAccountItem.title,
                        desc : pAccountItem.desc,
                        paramsArray:pAccountItem.paramsArray,
                        totalFee : pAccountItem.totalFee,
                        needPayDays : pAccountItem.needPayDays,
                        hasPayDays : pAccountItem.hasPayDays,
                        everyDayPay: Math.floor(pAccountItem.totalFee / pAccountItem.needPayDays),
                    },
                ];
                NormalGameManager._instance.setGameData( { userAccountInfo:accountItem },true );
                NormalGameManager._instance.setGameData( { userAccountInfoNewMsg : 1 },false );
                O1HD.emit("normalMode.loanSuccess",accountItem[0].desc , accountItem[0].paramsArray );
                O1HD.getServices().userSrv.setCoins(param["money"],true,node);
            }
            let weChatLink = param["weChatLink"];
            if(weChatLink !=null){
                // 打开微信聊天
                this.onTriggerWeChatLink(weChatLink);
            }
            NormalGameManager._instance.setGameData({hasBankCooperativeData:[data.id]},true);
            NormalGameManager._instance.onAddOneBankBusiness();
            this.closeThis();
        }
        let videoFlag:boolean = data.videoFlag;
        if(videoFlag){
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.isTrue = true;
                handleFun();
            },()=>{},null,"看广告办理银行业务");
        }else{
            this.isTrue = true;
            handleFun();
        }
        //  完善属性方法
        // node.destroy();
        // node.removeFromParent();
    }

    async onTriggerWeChatLink(linkId:string){
        let weChatId = linkId;
        let isTrue = NormalGameManager._instance.addOneWeChatTriggerLinkUnShift( `${weChatId}` );
        if(!isTrue) return;
        // await this.mGameLayer.mGameLayer.onBtnOpenPrefab(null,"weChat");
        //聊天链
        let link = getOneWeChatTriggerTimeLinkById( weChatId );
        //聊天链的初始端
        let chitChat = getOneChitAryById(link.link[0].id);
        //聊天对象 信息
        let people = NormalGameManager._instance.weChatManager.getOnePeopleById(chitChat.people);
        //聊天对象的队列
        let chitChatQueue = people.peopleChatLinkQueue;
        let chatFramePrefab = await getOneBundleOnePrefab( BUNDLE_SMALL_NAME.WeChatGameBundle, "weChat/prefab/WeChatFrame" );
        let chatFrame = cc.instantiate( chatFramePrefab );
        let cs = chatFrame.getComponent( WeChatFrame );
        if( chitChatQueue.length >0 ){
            // let chitChat = getOneChitAryById();
            cs.bindData( chitChatQueue[0],[] , people , ()=>{

            });
        }
        chatFrame.group = "UI";
        O1HD.getModules().uiControlModule.getUIRoot().addChild(chatFrame);
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.complete && this.complete(this.isTrue);
        this.node.destroy();
        this.node.removeFromParent();
    }

}
